
import * as React from "react"
import Table from 'react-bootstrap/Table';
import ExpandableText from "./expandableText";
import {NavigationBar, Layout} from "./layout"
import { Typography, Box, Stack } from "@mui/material";

const stories=[
{
  title: '大乘祖师',
  date: '2021-10-01',
  shortText: `大乘佛教有一类特别的法师被称为祖师。他们有以下的特征：



    他们是开悟的老师。这意味着他们是由开悟的祖师认可的，不像现代的很多老师自诩已经开悟，却没有这个至关重要的认证。这些自诩开悟的老师可能可以骗过普通人，却他们无法误导真正的佛教圣贤。除了真正的祖师以外，开悟的老师极少在私下承认自己开悟了，更不要说在公开场合了。
    每一个祖师都是有认证的老师，这就是说他们都是由另一位祖师所认证的。正因为如此，大乘初祖，摩诃迦叶尊者，是释迦摩尼佛认证的。摩诃迦叶尊者接着任命阿难尊者为二祖。正统佛教的历代的祖师就是这样从一代传到下一代。
    大乘祖师们的职责是弘扬正统佛教(理论)，也叫正法。也就是说，他们所授的与佛所授的一致。因此，初入佛门的弟子最好从祖师所教的学起，来得到正确的参照点并为以后的修行打好正确的基础。因此，佛教祖师的一个基本任务是帮助解释说明佛深刻的教导，不然我们无法理解。
    最后一个我们所知的大乘祖师（也是美国的初祖）是宣化上人，法界佛教总会的创始人。当他入涅槃前，钦点了二祖，但是直到撰写本文时（宣化法师圆寂25年以后），他还没有向世人透露自己的身份。`,
  fullText: `大乘佛教有一类特别的法师被称为祖师。他们有以下的特征：



    他们是开悟的老师。这意味着他们是由开悟的祖师认可的，不像现代的很多老师自诩已经开悟，却没有这个至关重要的认证。这些自诩开悟的老师可能可以骗过普通人，却他们无法误导真正的佛教圣贤。除了真正的祖师以外，开悟的老师极少在私下承认自己开悟了，更不要说在公开场合了。
    每一个祖师都是有认证的老师，这就是说他们都是由另一位祖师所认证的。正因为如此，大乘初祖，摩诃迦叶尊者，是释迦摩尼佛认证的。摩诃迦叶尊者接着任命阿难尊者为二祖。正统佛教的历代的祖师就是这样从一代传到下一代。
    大乘祖师们的职责是弘扬正统佛教(理论)，也叫正法。也就是说，他们所授的与佛所授的一致。因此，初入佛门的弟子最好从祖师所教的学起，来得到正确的参照点并为以后的修行打好正确的基础。因此，佛教祖师的一个基本任务是帮助解释说明佛深刻的教导，不然我们无法理解。
    最后一个我们所知的大乘祖师（也是美国的初祖）是宣化上人，法界佛教总会的创始人。当他入涅槃前，钦点了二祖，但是直到撰写本文时（宣化法师圆寂25年以后），他还没有向世人透露自己的身份。

大乘佛教既有理论也有实践。因此，学术派可能了解理论却不了解实践。实践需要有认可的老师的特别训练。传统上正统佛教（由释迦摩尼佛创立）的主要宗派以禅修为主来培养有认证的老师们。

祖师们开悟的程度不同。虽然大多数的祖师的职责是传承大乘(弘法)，大祖师们，好像宣化上人，擅长教导我们怎么开悟（理论与实践），因为他在世之时带出了大批开悟的弟子。`
},
{
 title: "参战",
 date: "2021-10-01",
 shortText: `古人有下列何时不参战的准则：



    国家不和睦，不扩展领土。
    军队不和睦，不参战。
    交战时军队不和睦，不进军。
    进军时军队不和睦，不要不惜一切代价求胜。


人民必须感受到领导是有计划的，仔细评估一切选择，而且珍惜人民生命的，才会为了国家的利益而做出牺牲。`,
 fullText: `古人有下列何时不参战的准则：



    国家不和睦，不扩展领土。
    军队不和睦，不参战。
    交战时军队不和睦，不进军。
    进军时军队不和睦，不要不惜一切代价求胜。


人民必须感受到领导是有计划的，仔细评估一切选择，而且珍惜人民生命的，才会为了国家的利益而做出牺牲。

​
这些准则适用于国家和在微观层面上也适用于家庭。

重要的是，在向外拓展的时候，整个单元（不论是国家还是公司或者家庭）都必须和谐。和谐是成大事的第一先决条件。`
},
{ title: "重义轻财",
 date: "2021-10-01",
 shortText: `范仲淹一度是宋朝的宰相，但是他一生清贫。他重义轻财并且乐于布施。他省下自己的俸禄买了千亩良田，并将经营所得用于慈善事业。无论是谁筹办婚礼、葬礼需要帮助，都可以找他求助。

他的儿子范純仁发扬了他父亲的优秀品质。当他是一个小镇的官吏时，一次他省钱买了五大桶米送给父亲。在回家的路上他碰到他父亲的一个老朋友，这位老朋友处在困难时期，刚有三个家人去世。純仁于是将这五桶米送给他。当他了解到父亲朋友的两个女儿因为没有嫁妆而无法出嫁的时候，就把自己的船也给了他们。

儿子空着手回到了家里。他的父亲问起了他的归途。

儿子说道，“我遇到了你的老朋友，他的经济困难，而且家里刚有三个人去世，所以我把本来准备带回家的五桶米给了他们，但是我怕可能这些还不够。

“你怎么不把船也给他们呢？”父亲问道。

“我给了。”純仁答道。

父亲大呼“好孩子！”`,
 fullText: `范仲淹一度是宋朝的宰相，但是他一生清贫。他重义轻财并且乐于布施。他省下自己的俸禄买了千亩良田，并将经营所得用于慈善事业。无论是谁筹办婚礼、葬礼需要帮助，都可以找他求助。

他的儿子范純仁发扬了他父亲的优秀品质。当他是一个小镇的官吏时，一次他省钱买了五大桶米送给父亲。在回家的路上他碰到他父亲的一个老朋友，这位老朋友处在困难时期，刚有三个家人去世。純仁于是将这五桶米送给他。当他了解到父亲朋友的两个女儿因为没有嫁妆而无法出嫁的时候，就把自己的船也给了他们。

儿子空着手回到了家里。他的父亲问起了他的归途。

儿子说道，“我遇到了你的老朋友，他的经济困难，而且家里刚有三个人去世，所以我把本来准备带回家的五桶米给了他们，但是我怕可能这些还不够。

“你怎么不把船也给他们呢？”父亲问道。

“我给了。”純仁答道。

父亲大呼“好孩子！”
这些君子的故事很好的诠释了大乘佛教布施的传统，布施到心痛，然后继续布施。`
},
{ title: "包容",
 date: "2021-10-10",
 shortText: `鸣不能变得小声而与钟鸣相容。
日月光无法弯曲来照亮小巷。
大河无法变窄让人更易越过。
高山无法变矮来取悦业余攀岩者。

相似的，大马车无法收缩轮轴来驶入窄巷。
君子无法降低自己来获得贱人认可。`,
 fullText: `鸣不能变得小声而与钟鸣相容。
日月光无法弯曲来照亮小巷。
大河无法变窄让人更易越过。
高山无法变矮来取悦业余攀岩者。

相似的，大马车无法收缩轮轴来驶入窄巷。
君子无法降低自己来获得贱人认可。


因此像我们这样的普通人不应该对别人妄加评判，非议不一样和不合拍的人。因为在这些人之中就有来改变世界的真君子。`
},

{ title: "预防疾病",
 date: "2021-10-01",
 shortText: `扁鹊是春秋时期的名医。有一次他去见齐王（也被称为蔡桓公，齐桓公）。看诊后，扁鹊告诉齐王他有肌肤上的问题，应该在恶化之前去治疗。

齐王说自己没有病，于是扁鹊就走了。齐王嘲笑道，“好一个骗子，想治疗没病的人来获得名声。”

十天之后，扁鹊又来见齐王，告诉他：“陛下的病已经到了肠胃，需要赶紧治疗。”

齐王听了面现不悦，于是扁鹊又走了。

又过了十天，扁鹊再一次去见齐王。他看了齐王一眼转身就走。齐王派人去追问扁鹊为什么这么匆忙的离开。扁鹊说道，“病在肌肤，针灸可以治，病在肠胃，汤药可以治，一旦病入骨髓，就无可奈何了”

五天之后，齐王果然病了而且没有医生能够医治他（扁鹊已经逃到了秦国），最后死了。`,
 fullText: `扁鹊是春秋时期的名医。有一次他去见齐王（也被称为蔡桓公，齐桓公）。看诊后，扁鹊告诉齐王他有肌肤上的问题，应该在恶化之前去治疗。

齐王说自己没有病，于是扁鹊就走了。齐王嘲笑道，“好一个骗子，想治疗没病的人来获得名声。”

十天之后，扁鹊又来见齐王，告诉他：“陛下的病已经到了肠胃，需要赶紧治疗。”

齐王听了面现不悦，于是扁鹊又走了。

又过了十天，扁鹊再一次去见齐王。他看了齐王一眼转身就走。齐王派人去追问扁鹊为什么这么匆忙的离开。扁鹊说道，“病在肌肤，针灸可以治，病在肠胃，汤药可以治，一旦病入骨髓，就无可奈何了”

五天之后，齐王果然病了而且没有医生能够医治他（扁鹊已经逃到了秦国），最后死了。
普通人往往会忽视自己的疾病，可能是因为普通的医生不能觉察到重疾。扁鹊医术高超，因此可以发现骨髓病变，但还是不能医治这种病。

当你的定力够高的时候，禅修可以帮助你自愈骨髓病变。通常，如果你每天修禅，病不太可能发展到骨髓之中。`
},
{ title: "国家的衰亡",
 date: "2021-10-01",
 shortText: `古人是通过什么样的征兆来知道国家在走向衰落呢？

国家屯粮筑墙，忽视民生却有信心抵御外敌。国王不为国家主权鞠躬尽瘁，王子懦弱胆怯。富裕的精英们挥金如土，而且纵欲。官员们蛮横贪婪而且无情。政府严重两极分化，而且没有人愿意承担责任。

如果这个国家恰巧在两个强国之间，十年之内必被吞并。`
 ,fullText: `古人是通过什么样的征兆来知道国家在走向衰落呢？

国家屯粮筑墙，忽视民生却有信心抵御外敌。国王不为国家主权鞠躬尽瘁，王子懦弱胆怯。富裕的精英们挥金如土，而且纵欲。官员们蛮横贪婪而且无情。政府严重两极分化，而且没有人愿意承担责任。

如果这个国家恰巧在两个强国之间，十年之内必被吞并。
这样的一个国家在作贱自己，邀请其他国家来吞并他们。`
},
{ title: "孔明给他儿子的信",
 date: "2021-10-01",
 shortText: `孔明（诸葛亮）是中国历史上集智慧，机敏与忠诚于一身的传奇人物，他曾给他儿子留下了这样的一封信。

夫君子之行，静以修身，俭以养德；非淡泊无以明志，非宁静无以致远。夫学须静也，才须学也；非学无以广才，非志无以成学。

怠慢则不能励精，险躁则不能冶性。年与时驰，意与岁去， 遂成枯落，多不接世。悲守穷庐，将复何及！​`
 ,fullText: `孔明（诸葛亮）是中国历史上集智慧，机敏与忠诚于一身的传奇人物，他曾给他儿子留下了这样的一封信。

夫君子之行，静以修身，俭以养德；非淡泊无以明志，非宁静无以致远。夫学须静也，才须学也；非学无以广才，非志无以成学。

怠慢则不能励精，险躁则不能冶性。年与时驰，意与岁去， 遂成枯落，多不接世。悲守穷庐，将复何及！​
亚洲文化强调修身养性。一个人必须努力学习知识，发掘才能。

佛教教导我们要修戒定慧，来实现我们最大的潜能。`
},
{ title: "你已经知道了",
 date: "2021-03-01",
 shortText: `纯真和无善无邪，这是我们出世时的本性。

好善恶恶是因为我们(大多数人)都习惯这么做。

颠倒黑白是我们被坏习惯影响的结果，这让我们持续走下坡路。

通过修行我们可以改邪归正，这帮助我们持续进步。

退步或进步，你自己心里清楚：不要试图蒙骗自己。要努力！`,
 fullText: `纯真和无善无邪，这是我们出世时的本性。

好善恶恶是因为我们(大多数人)都习惯这么做。

颠倒黑白是我们被坏习惯影响的结果，这让我们持续走下坡路。

通过修行我们可以改邪归正，这帮助我们持续进步。

退步或进步，你自己心里清楚：不要试图蒙骗自己。要努力！
以上是中国圣贤对他们学生的教导。很多的圣贤出现在中国，这就是中国文化博大精深的原因。

当你修成的时候，就会意识到你早就已经懂这些教导了。`
 },
{ title: "你可以依賴這個人",
 date: "2021-02-01",
 shortText: `世上有两难，去天堂难，但求人帮忙更难。

世上有两苦，黄连苦，但贫困更苦。

世上有两薄，刚结的冰面薄(如果你踩上去的话会有大麻烦)，但依赖他人更薄。

世上有两险，山河险峻，但人心更险。`,
 fullText: `世上有两难，去天堂难，但求人帮忙更难。

世上有两苦，黄连苦，但贫困更苦。

世上有两薄，刚结的冰面薄(如果你踩上去的话会有大麻烦)，但依赖他人更薄。

世上有两险，山河险峻，但人心更险。
知难意味着你独立不求人。忍苦是有耐心，因此你可以长久。知薄意味着你宽容，可以和小人共事。知险的人聪明且善解人意。
 
这样的人能干并且可以成事。

最重要的是选一个道德高尚的人，他不会欺骗你！`
 },
{ title: "染绸",
 date: "2021-01-01",
 shortText: `中国哲学家墨子看到染绸的场景而悟到了下面的道理：
 
丝绸碰到绿色染料变绿，碰到黄色染料变黄。丝绸的颜色随着染料而变。染五次丝绸的颜色就变五次，所以染料需要小心使用。
 
类似的，人也会互相这样染色，近朱者赤近墨者黑。名声好坏在很大程度上取决于你所接触的人。`,
 fullText: `中国哲学家墨子看到染绸的场景而悟到了下面的道理：
 
丝绸碰到绿色染料变绿，碰到黄色染料变黄。丝绸的颜色随着染料而变。染五次丝绸的颜色就变五次，所以染料需要小心使用。
 
类似的，人也会互相这样染色，近朱者赤近墨者黑。名声好坏在很大程度上取决于你所接触的人。
 *****
​ 
墨子只能看到朋友的层面，但是没有看到老师的层面。在佛教，大成或大败在很大程度上取决于善知识。`
 },
{ title: "一位官员的崇高地位",
 date: "2020-12-01",
 shortText: `一位睿智的老官员对新任的官员说：“官为民服务，而不是民必须为官服务。 人们缴税是为了支付官员的薪水，以便官员能为百姓执法公证。不幸的是，如今我们很伤感地看到官员收取薪水却迟延公务，在某些情况下甚至从人民身上偷盗。`,
 fullText: `一位睿智的老官员对新任的官员说：“官为民服务，而不是民必须为官服务。 人们缴税是为了支付官员的薪水，以便官员能为百姓执法公证。不幸的是，如今我们很伤感地看到官员收取薪水却迟延公务，在某些情况下甚至从人民身上偷盗。
既然你要担任这个重要的官职，那么你应该早上早起并且晚上工作到很晚来履行你的职责。 您必须勤奋地履行自己的公职，对诉讼做出公正的判决，定出公平合理的费用，平等对待老年人和年轻人。 只有那样，你才能对得起你的薪水。”
 
*****
 
这适用于包括政客在内的各级公务员。
 
你可以随意花言巧语。但是底线是，伟大的官员将为国家带来繁荣与安定。 差劲的官员会损害国家财政，削弱国家在世界上的地位。 历史将会证明一切。`
 },
{ title: "别那么死板",
 date: "2020-11-01",
 shortText: `古人说：
 
过了季节，上天也不能使花朵盛开。 因此，圣人遵守时效性。
 
大地母亲无法改变季节。 因此，圣人不会违背传统。`,
 fullText: `古人说：
 
过了季节，上天也不能使花朵盛开。 因此，圣人遵守时效性。
 
大地母亲无法改变季节。 因此，圣人不会违背传统。
即使圣人也不能用手走路或者用脚拿东西。 因此，圣人必须知道他们的局限性。
 
圣人不能使鱼飞行，也不能使鸟游泳。 因此，圣人必须尊重他人的局限性。
 
因此，睿智的人知道什么时候该前进，什么时候该后退。 什么时候应该清楚，什么时候应该含糊。 一个人不应该死板。
 
* * * * *
 
从理论上讲，头脑清晰的人和睿智的人可以看得更远和更广（全局）。
 
但是，佛教有“所知障”这个概念：障碍和阻止你的是你自己的聪明，知识和智能。
 
在这种情况下，解决这个问题的更快方法是遵从你的善知识的指点。`
 },
{ title: "百姓第一",
 date: "2020-10-01",
 shortText: `孟子认为，国家要强大，就需要三个组成部分：
 

    1. 百姓
    2. 土地
    3. 君王`,
 fullText: `孟子认为，国家要强大，就需要三个组成部分：
 

    1. 百姓
    2. 土地
    3. 君王

按照这个顺序。
 
百姓虽然缺乏权威和权力，却拥有群众的力量，所以他们排在第一。
  
土地来自中国的社稷理念； 社是指土地守护神，而稷指负责农作物（收割）的神。 中国人意识到，每一方土地都有土地神守护，收割神会影响收成。 尽管土地得到了神的庇佑，但是神需要通过百姓的供养和祈祷来护持。因此，百姓胜过了土地。
最后，君主是神和百姓的领袖。 但是，他必须依靠百姓的支持和爱戴以及神的护佑才能继续工作。 因此君王排在第三位。
  
佛教徒有一个秘密。
 
为了使百姓受良好的教育和过得好，为了使神护持，和为了让君王成为一个好的领袖，你要请圣贤来住在你的国家。 然后，百姓就会受到正当的教育并且变得明智，神将会最大程度地护持，而且当选的君主可以成为贤良的领袖。`
 },
{ title: "如何治国",
 date: "2020-09-01",
 shortText: `子产是一位著名的学者。他成为中国郑国的一位伟大的政治家和卿。他是一位非常仁慈的领袖。
 
子产病重的时候，他叫来子太叔说：“我死后，你必定会执掌国政。您应该知道，有德行的人必须用仁慈与和谐来激起人民的尊重，而普通人必须要让百姓敬畏与严厉来统治国家。
 
这就像火。因为热，它会让人产生恐惧，这就是为什么很少有人死于火。然而，水是凉的，它让人低估它的危险，因此更多人会溺亡。总而言之，又要仁慈而又要创造和谐并不容易。”`,
 fullText: `子产是一位著名的学者。他成为中国郑国的一位伟大的政治家和卿。他是一位非常仁慈的领袖。
 
子产病重的时候，他叫来子太叔说：“我死后，你必定会执掌国政。您应该知道，有德行的人必须用仁慈与和谐来激起人民的尊重，而普通人必须要让百姓敬畏与严厉来统治国家。
 
这就像火。因为热，它会让人产生恐惧，这就是为什么很少有人死于火。然而，水是凉的，它让人低估它的危险，因此更多人会溺亡。总而言之，又要仁慈而又要创造和谐并不容易。”
​几个月后，子产去世，子太叔取而代之执政。然而，他发现他的内心没有严厉和猛力。相反，他选择用仁慈与和谐来执政。结果，这个国家有了很多土匪和强盗。因此，子太叔意识到了自己方法上的错误。他遵循了子产的信条，派兵抓捕并刑罚了土匪和强盗。
 
当孔子听到这个故事时，评价道：“确实好啊！当统治者仁慈时，百姓就会行为不端。当百姓不遵守法规，则必须使用武力。当使用武力时，百姓就会消亡和虚弱。然后，执政者又必须重归仁政。仁慈可以协助武力，而武力也可以衬托仁慈：这就是和谐。”
 
 
* * * * *
 
 
儒家认为和谐只是佛教的中道：这是管理人的一种艺术, 要在有美德的同时保持平衡。
 
正如我已故老师指出的那样，除了政治手段，国家领导人还必须以保持道德为核心。`
 },
{ title: "忠诚和个人主义",
 date: "2020-08-01",
 shortText: `在齐国，有一位朝廷大臣。他被封赏了土地、钱财和官衔，非常的富裕。当齐王遇险时，他拒绝牺牲自己的生命去救齐王。

有一天，他遇到一个老熟人，这位老熟人惊讶地看着他说，“我以为你死了！

他平静地答道：“不，正如你所看到的，我还活着。 我是齐王的臣民，因为这是有益的。 和他一起死没有好处，所以我拒绝和他一起死。”
​
他的老熟人说：“如果那样的话，你怎么可以面对你的祖先？”
​
他立即反驳说：“所以，你真的相信死后会见到祖先吗？`,
 fullText: `
在齐国，有一位朝廷大臣。他被封赏了土地、钱财和官衔，非常的富裕。当齐王遇险时，他拒绝牺牲自己的生命去救齐王。

有一天，他遇到一个老熟人，这位老熟人惊讶地看着他说，“我以为你死了！

他平静地答道：“不，正如你所看到的，我还活着。 我是齐王的臣民，因为这是有益的。 和他一起死没有好处，所以我拒绝和他一起死。”
​
他的老熟人说：“如果那样的话，你怎么可以面对你的祖先？”
​
他立即反驳说：“所以，你真的相信死后会见到祖先吗？
在古代，如果有人从君主那里得到恩宠，却又不愿意为君主而死，那就是极大的不忠。

在现代，这种思维逻辑被认为是过时的。 我们认为人际关系是互惠互利的：你给我些东西，然后我才回报。

哪一个是合理的呢？ 这取决于你从哪方面看这个问题。 如果你自己担任法官，那么如不忠的官员的行为是理所当然的，因为“自我”不愿蒙受损失。

就我个人而言，在我遇到我老师宣化上人之前，是凄惨而邪恶的。 他接受了我并教我如何修行。 因为修行，我彻底改变了自己，成为与之前的我相反的一个人。 因此，我的生命属于我的先师。 所以，我并不把它看成是忠诚，但我会把余生致力于帮助继续我师父的工作，来报答他的善行，对我来说，这是偿还你的债务。
`
 },
{ title: "只见自我",
 date: "2020-07-01",
 shortText: `古人说：
​
人犯下无量罪业是由于 “只见自我”这种病。因此，他日夜谋划想变得更富有，爬上社会阶梯，增强自己的安全网，沉迷于享乐，确保自己的生存，延长自己的寿命，而又不在乎别人是否穷苦贫困， 经历危险和困难，悲惨地失败或丧生。 换句话说，他不在乎其他生命，也不尊重道德和礼节。 因此，他可能有人身，但他并不比动物好到哪里去。`,
 fullText: `古人说：
​
人犯下无量罪业是由于 “只见自我”这种病。因此，他日夜谋划想变得更富有，爬上社会阶梯，增强自己的安全网，沉迷于享乐，确保自己的生存，延长自己的寿命，而又不在乎别人是否穷苦贫困， 经历危险和困难，悲惨地失败或丧生。 换句话说，他不在乎其他生命，也不尊重道德和礼节。 因此，他可能有人身，但他并不比动物好到哪里去。
​如果人类能够摆脱这种“我为先”的疾病，并且他们的心胸宽广、公正，那么无论富裕和崇高，贫穷和卑微，遇险和受苦，经历惨败，有失去生命的危险，他们仍然遵从着道德和礼节与所有其他人交流：这才是真正的自我和他人融为一体。”

* * * * *
现代社会的最新发展可以归因于个人文化。 但是，为了确保不断的进步，我们必须意识到要把利益他人作为我们道德准则的一部分。 否则，如果我们继续自我放纵，我们无底的贪婪心将对世界造成巨大伤害。`
 },
{ title: "伟人的4个考量",
 date: "2020-06-01",
 shortText: `子产是有名的学者。他在郑国成为伟大的政治家、将军。他教导说伟人有四个优越的特质

1. 有自尊。
2. 尊重上级。`,
 fullText: `
子产是有名的学者。他在郑国成为伟大的政治家、将军。他教导说伟人有四个优越的特质

1. 有自尊。
2. 尊重上级。
​3. 用善（修布施）和智慧来引导他人。
4. 用义来领导国家。
这样更容易给国内带来和平和和谐，同时获得其他国家的尊重和畏惧。
* * * * *
这源于他为他的国家服务40多年积攒起来的智慧。
`
 },
{ title: "义胜过私爱",
 date: "2020-05-01",
 shortText: `齐军进攻鲁国。当他们过国界线时，有个女人一手抱着一个孩子，另一手牵着另一个孩子。当她看到士兵们，他放下手中抱的孩子，抱起另一个孩子跑了。她留下的那个孩子哭着跑在她后面，但她连看也不看。

齐国的将军很好奇，命令他的士兵们抓住那个女人来审问。`,
 fullText: `齐军进攻鲁国。当他们过国界线时，有个女人一手抱着一个孩子，另一手牵着另一个孩子。当她看到士兵们，他放下手中抱的孩子，抱起另一个孩子跑了。她留下的那个孩子哭着跑在她后面，但她连看也不看。

齐国的将军很好奇，命令他的士兵们抓住那个女人来审问。
问道两个孩子的时候她说道：“我留下的那个孩子是我的，另一个是我兄长的。”
 
齐国将军问：“有抛下自己的亲身骨肉来保护你兄长的孩子？”
 
她回答道:“我的儿子是我的私爱，但是我兄长的孩子是义。牺牲我的亲身孩子可能会很受伤害，但是如果我抛弃兄弟的儿子，那就是不忠。之后我如何在我的国家生存？”
 
齐国将军命令出征的军队停止，并送信给齐国国君说道，一个低微的女人如此的义，何况这个国家的长官、将军们呢？攻击的时机还不成熟。齐国国君同意了并命令他的军队撤退。
 
后来鲁国的国君听说了这个故事，表彰了那个女人并给她大赏赐。

***
 
依义生活，消灾免难。`
 },
{ title: "正义带来爱情",
 date: "2020-04-01",
 shortText: `一位有钱的太太回家看望家人。她的女仆搬着太太的珠宝箱一起去。女仆把珠宝箱放错了地方。之后才意识到，因此疯狂地回去寻找。
 
她看到一个乞丐拿着珠宝箱坐在路边。立刻过去要珠宝箱。乞丐立刻把珠宝箱还给了她。`,
 fullText: `一位有钱的太太回家看望家人。她的女仆搬着太太的珠宝箱一起去。女仆把珠宝箱放错了地方。之后才意识到，因此疯狂地回去寻找。
 
她看到一个乞丐拿着珠宝箱坐在路边。立刻过去要珠宝箱。乞丐立刻把珠宝箱还给了她。
女仆很高兴。她脱下手环给了乞丐，乞丐说道：“珠宝箱都不能令我动心。我怎么会要你的手环呢？”
 
女仆说道：“我掉了这个珠宝箱会受到很严重的惩罚。你把它还给我，因此你不但给我宝物还救了我的命。尽管你不求回报，但是我不能不感恩。我住的离这不远，请在用餐时间过来，我很高兴和你分享我的食物。”
 
乞丐回答道：“你在里面，怎么会知道我到了呢？”
 
她说：“我屋前面，有一颗高竹子。请摇它来通知我你到了。”
 
所以他就照做了，她每天都和他分享她的食物。
 
其他的仆人发现了报告给主人，主人立即召唤女仆来调查。听了她的故事以后，仁慈的主人叫来了乞丐，给他一份工作，并和女仆结婚。
 
他们继续赢得主人的信任并得到丰厚的回报。他们以后一直幸福的生活着。
 

 
贫穷但不贪婪。一个人应当偿还感恩的债。
古老的爱情故事！`
 },
{ title: "拜访一个政治家",
 date: "2020-03-01",
 shortText: `一位政治官员上任。他的臣民为他举办了一个大宴会来庆祝。
 
庆祝快结束的时候，一位穿着粗布白色长袍的老者也来见这位政治家。他立刻穿上最好的衣服来迎接这位访问者说：“我们的国君没有意识到我没有天赋而且过度信任。所以他指派我到这里任职。我非常感激这个热烈的欢迎。现在您来拜访，心中一定有什么想法。”`,
 fullText: `一位政治官员上任。他的臣民为他举办了一个大宴会来庆祝。
 
庆祝快结束的时候，一位穿着粗布白色长袍的老者也来见这位政治家。他立刻穿上最好的衣服来迎接这位访问者说：“我们的国君没有意识到我没有天赋而且过度信任。所以他指派我到这里任职。我非常感激这个热烈的欢迎。现在您来拜访，心中一定有什么想法。”
​老者说：“正是。傲慢的当权者会被人批评。专治的高官会被君主讨厌。当一个人报酬丰厚而依然腐败的时候，灾难就会落到那个人身上。”
 
政治家合掌说：“谢谢你智慧的言语。请教导我更多。”
 
老者继续说：“当政者必须谦卑和恭敬。一个人有权时必须敏感而温和。报酬丰厚的腐败官员会有麻烦。你执政时，请记住这三件事。”
 

 
贫穷而卑微的人学习福德之道会得到财富和地位。富裕而有权的人拥有美德可以享受他们的福报更久。
 
富裕而有权的人傲慢且自我放纵会不可避免的遇到麻烦和困境。
 
老者的话同样适用于政治家和富裕和有特权的人。
 
最后，财富和权利是一个人福报的体现。要在福报用尽之前趁此机会补充你的福报。`
 },
{ title: "大局",
 date: "2020-02-01",
 shortText: `庄子是著名的老子的传统道教弟子。他的妻子过世了。他的密友，学者和政治家惠子前去吊唁，发现他在鼓盆而歌。
 
惠子说：“你和她结婚生子。现在她过世了，你不用哀悼她，这可以理解，但是你竟在唱歌？”`,
 fullText: `庄子是著名的老子的传统道教弟子。他的妻子过世了。他的密友，学者和政治家惠子前去吊唁，发现他在鼓盆而歌。
 
惠子说：“你和她结婚生子。现在她过世了，你不用哀悼她，这可以理解，但是你竟在唱歌？”
​庄子回答道：“你误会我了。当我妻子过世时，开始时我很伤心。但是，想了一想，觉得这根本没什么。本来就没有形体或气息。人的生命是由繁杂的物质转化为气息，气息再转化成人形而形成的。生命然后又转化为死亡就像四季不断循环变化一样。因此，死亡就像是旅客回家一样。啼哭和哀悼只是没有意识到生命的循环。那就是为什么我决定要唱歌。”
 
*******
 
和佛教徒相比，道教的智慧基本上错过了大局。他们理解空和回归尘土。但是他们还是不明白轮回。
 
他的妻子没有控制地继续在轮回中转世。在佛教，我们会设法以她的名义为她修福，这样她可以得到一个更好的身体并且向着解脱和幸福提升。更好的是，更有福报的佛教徒甚至可以往生西方极乐世界，那里她将只有乐，再也不用遭受痛苦了。`
 },
{ title: "分享爱",
 date: "2020-01-01",
 shortText: `国王刚刚选了一位新皇妃，无以伦比的美丽。因此，他很爱慕并宠爱她。
 
皇后也知道，所以也显示自己爱慕新皇妃并恩宠和奖赏她，以至于新皇妃什么都不缺。
 
国王很满意，称赞皇后说：“我的妻子真的很宠新皇妃。我说她有时比我更宠爱她。这是儿子孝顺父母和臣子忠于国王的典型。”`,
 fullText: `
国王刚刚选了一位新皇妃，无以伦比的美丽。因此，他很爱慕并宠爱她。
 
皇后也知道，所以也显示自己爱慕新皇妃并恩宠和奖赏她，以至于新皇妃什么都不缺。
 
国王很满意，称赞皇后说：“我的妻子真的很宠新皇妃。我说她有时比我更宠爱她。这是儿子孝顺父母和臣子忠于国王的典型。”
皇后知道自己得到了所有人的信任，就对新皇妃说：“国王真的很爱你。但是他不喜欢你的鼻子。因此，你应该在国王面前遮着你的鼻子：这样他就会永远宠你。”
 
所以新皇妃照做了。
 
国王对她的行为很吃惊，于是问皇后，皇后说她不知道。追问后，她终于向国王承认王妃告诉她，她不能忍受国王的体味。
 
听说此事，国王大发雷霆，下令割掉皇妃的鼻子并扔出宫门。
 
爱可以分享吗？
`
 },
{ title: "疯狂的傻瓜",
 date: "2019-12-01",
 shortText: `有一个疯子。 他在泥里打滚，踩在荆棘和鬃毛上。他总自我满足，争辩自己是正确的。
 
后来他遇到了一位有能力的医生可以治愈他。结果，他渐渐好了起来直到完全康复。`,
 fullText: `有一个疯子。 他在泥里打滚，踩在荆棘和鬃毛上。他总自我满足，争辩自己是正确的。
 
后来他遇到了一位有能力的医生可以治愈他。结果，他渐渐好了起来直到完全康复。
​他的朋友和亲戚们会跟他描述他过去的情况。他发抖，感觉自己非常有幸遇到这么一位好医生来治愈他，以免他一生悲惨。他甚至希望自己可以早些遇到好医生。
 

 
这个世界有许多无法治愈的疯子。还有很多可以医治的疯子拒绝治疗。他们甚至辱骂好医生是要试图欺骗他们的江湖医生。
 
疯狂的的傻瓜代表一个被自己贪嗔痴所蒙蔽的人：他完全颠倒还相信自己是对的。他坚持自己的方法，拒绝治疗，还会辱骂可以了却他痛苦的好医生。`
 },
{ title: "三件乐事",
 date: "2019-11-01",
 shortText: `古人认为优越的人有三件比当国王更快乐的事。
父母健在，兄弟姐妹安全健康：那是一件快乐的事。
不会被天罚，对人问心无愧：那是另一件快乐的事。
接受圣贤的教导，那是另一件非常快乐的事。`,
 fullText: `古人认为优越的人有三件比当国王更快乐的事。
父母健在，兄弟姐妹安全健康：那是一件快乐的事。
不会被天罚，对人问心无愧：那是另一件快乐的事。
接受圣贤的教导，那是另一件非常快乐的事。
​*****

当父母健在，兄弟姐妹安全健康时，我们有机会修孝道，心中快乐。
当良心自由纯净时，头脑快乐。
当我们从伟人那里得到帮助和指点是，精神快乐。`
 },
 { title: "以正当收入供养母亲",
 date: "2019-10-01",
 shortText: `Roãn Thuần参加科举考试。文章的题目是“杀掉前朝的忠诚者”（以便对现在的皇帝忠诚）Roãn Thuần立刻站起来走了。
 
他马上汇报给他的老师并宣告他再也不考科举了。他睿智的老师说，“你如何照料你年长的母亲呢？”`,
 fullText: `Roãn Thuần参加科举考试。文章的题目是“杀掉前朝的忠诚者”（以便对现在的皇帝忠诚）Roãn Thuần立刻站起来走了。
 
他马上汇报给他的老师并宣告他再也不考科举了。他睿智的老师说，“你如何照料你年长的母亲呢？”
Roãn Thuần直接回家向他年迈的母亲解释状况。她告诉他，“我更喜欢你用正当的收入来照顾我而不是非法收益。”
 
当Roãn Thuần的老师听到她的回答后惊说，“有其母必有其子！”

那些愿意为个人利益背叛前朝好皇帝的人不是社会的好公民。
 
非法收益，不论多么营养或美味，都很难消化并且危害我们良好的天性。
 
那位女士的品行是基于佛教的因果原则。举例说，我们偷别人所获的利益实际上是必须加利息偿还的业债。那些从如此非法利益中获利的人，比如家人，也要担负他们份的业债偿还。`
 },
 { title: "正直的人",
 date: "2019-09-01",
 shortText: `列子很穷，经常忍饥受渴。

​有人和国王汇报列子，说他是一个优秀出众的人但一贫如洗。如果别人听说他，会认为国王不识贤德。

​国王立即准备了三车食物运给列子。`,
 fullText: `
列子很穷，经常忍饥受渴。

​有人和国王汇报列子，说他是一个优秀出众的人但一贫如洗。如果别人听说他，会认为国王不识贤德。

​国王立即准备了三车食物运给列子。
​列子从房子里出来，恭敬地拜了使者并拒绝了赠予。

当他回去的时候，他的妻子沮丧而怨恨，说，“我听过说有才能的人的家人通常都被照顾得很好。但是你的家人这么一贫如洗，而且国王慷慨赠予来帮助，而你拒绝了。我怎么跟我们饿肚子的孩子们解释呢？”

列子对妻子 笑道，“亲爱的，国王只是因为有人在他面前说我好话才知道我，所以国王才送东西给我们。我拒绝他的赠予是因为他不真的了解我。这么想，如果将来有人在国王面前说我坏话，他会对我们怎么样？而且，如果我们接受他的礼物那么当他有难的时候，我们若不能牺牲生命来帮助他是为忘恩负义。另一方面，以死帮助一位恶君主又算什么德行？”

后来，国王真的遇难被杀。

* * * * *

我们都应该学习和效仿列子的美德和正直。为了不欠恶人而看着你所爱的人贫穷挨饿很不容易。

拥有美德很不容易，因为一个人必须要牺牲很多。
`
 },
 { title: "对妻子忠诚",
 date: "2019-08-01",
 shortText: `Cảnh Công是战国时期的一位国王。他有一位他钟爱的女儿，他想把她下嫁给他忠心的大将Án Tử(AT).。
一天国王到AT家吃晚饭。他看了一下AT的妻子问道，“这是你的妻子？”

​AT回答道，“是的，陛下。”`,
 fullText: `Cảnh Công是战国时期的一位国王。他有一位他钟爱的女儿，他想把她下嫁给他忠心的大将Án Tử(AT).。
一天国王到AT家吃晚饭。他看了一下AT的妻子问道，“这是你的妻子？”

​AT回答道，“是的，陛下。”
国王说，“天哪，她看上去又老又丑！我有一个年轻貌美的女儿，我想让她到你家来照顾你。你有兴趣吗？”

AT站起来回答道，“我的妻子现在年纪大了又不吸引人，但是她在年轻貌美的时候嫁给我。传统上，女人年轻的时候结婚，那么她们年纪大的时候可以依赖他们的丈夫，她们把自己全部奉献给丈夫们，所以当她们变得不吸引人的时候也会被照顾。我娶她时了解并同意这一点。我非常感恩陛下的善意恩赐，但是我相信您不会想我以背叛我对自己妻子的承诺来接受皇家的慷慨。”

也就是说，AT拒绝接受年轻貌美的公主。
____________________________________________________________________________________________________

AT 对他的国王和妻子如此的忠诚。
 
美貌只有皮肤的深度。非常有可能AT的妻子有美德而生的内在美，令她值得她丈夫的忠诚。`
 },
 { title: "担忧和喜悦",
 date: "2019-07-01",
 shortText: `孔夫子有名的弟子子路问他睿智的老师：“优越的人也会担忧吗？”
 
孔夫子回答： “优越的人只关心当前需要考虑的任务。他还没有开始前，因有志向和决心而快乐。当他完成任务时，因有能力和聪明而快乐。因此，优越的人只知道快乐而没有担忧。”`,
 fullText: `孔夫子有名的弟子子路问他睿智的老师：“优越的人也会担忧吗？”
 
孔夫子回答： “优越的人只关心当前需要考虑的任务。他还没有开始前，因有志向和决心而快乐。当他完成任务时，因有能力和聪明而快乐。因此，优越的人只知道快乐而没有担忧。”
相反，小人，还没有完成任务时，担忧他不能完成。如果他成功，又恐怕自己会失去。那就是为什么小人一生只有担忧。

​****
 
世人有太多忧虑因为他们的贪没有界限。
 
优越的人只贪帮助他人。那就是为什么他为自己尽全力而快乐而不是执着成果。`
 },
 { title: "两位妾",
 date: "2019-06-01",
 shortText: `Dương Chu (DC)是中国的一位知名学者，有一次旅行住在一所旅店里。旅店的主人有两位妾，一位美一位丑。美的那位不受人喜爱，但是丑的那位很受喜爱。DC问店里的孩子们为什么。他们说：“美太太因知道自己的美貌而失去了吸引力，我们不再觉得她漂亮。但是丑太太知道自己缺少美貌而为此弥补，因此我们都不觉得她没有吸引力。”`,
 fullText: `Dương Chu (DC)是中国的一位知名学者，有一次旅行住在一所旅店里。旅店的主人有两位妾，一位美一位丑。美的那位不受人喜爱，但是丑的那位很受喜爱。DC问店里的孩子们为什么。他们说：“美太太因知道自己的美貌而失去了吸引力，我们不再觉得她漂亮。但是丑太太知道自己缺少美貌而为此弥补，因此我们都不觉得她没有吸引力。”
​DC转向陪同他的学生们说：“你们要记住这点。优越的人要忘记他的优越性，如此他会变得讨人喜爱。无论到哪里他都会受欢迎。”
 
* * * * *
 
那些对自己才能或容貌过于自豪的人倾向于自负和自傲，因此不被他人喜爱和尊重。相反，那些没有才能和吸引力的人对自己的弱点更有觉知。他们学习如何用好的举止和谦逊来弥补。他们更受人喜爱，甚至更可能会被接受为配偶。
 
谦逊是美德的根本。这堂课要在孩子还易受影响时教。`
 },
 { title: "选择帮助谁",
 date: "2019-05-01",
 shortText: `杨虎是战国时代中国的高级将军。他遇到麻烦在临国避难逃命。他求见睿智的官员赵简称：“从今以后，我再也不帮助任何人了。”

询问中，杨虎解释道：“我在我国时，从国王那里帮助过过半的随从官员，令他们得到他们的职位；也帮助过过半的法庭官员；过半的边防官员也是因为我的支持而任职的。`,
 fullText: `
杨虎是战国时代中国的高级将军。他遇到麻烦在临国避难逃命。他求见睿智的官员赵简称：“从今以后，我再也不帮助任何人了。”

询问中，杨虎解释道：“我在我国时，从国王那里帮助过过半的随从官员，令他们得到他们的职位；也帮助过过半的法庭官员；过半的边防官员也是因为我的支持而任职的。



​​然而那些随从官员诽谤我，那些法庭官员用法律条文给我定罪，那些边防官员用他们的武器对付我！”
赵简说：“不对！那是你自作自受。谁让你帮助那些奸诈的人并期待他们感激。”
​
* * * * *
 
一个下劣的人只会拿他的问题来责怪他人而不看自己或改正缺点。
赵简甚至不该为杨虎解释，因为在这样一个下劣的人身上只会浪费时间。
`
 },
 { title: "从书本上学",
 date: "2019-04-01",
 shortText: `国王Hoàn Công在念书。（他是战国时期非常有能力的一位国王。）他造木轮的木匠问：“陛下在念什么？”

国王回答：“我在念圣贤人的教导。”

“他们还在世么？”

“不，他们都过世了。”`,
 fullText: `国王Hoàn Công在念书。（他是战国时期非常有能力的一位国王。）他造木轮的木匠问：“陛下在念什么？”

国王回答：“我在念圣贤人的教导。”

“他们还在世么？”

“不，他们都过世了。”

“那陛下只是在捡垃圾！”
 
 “大胆？快快解释不然我砍你的头。”

​“我只是从我做木轮的方法中推导。它们需要雕得恰到好处，不能太小也不能太大。每一次雕琢都不一样，没有什么预设的程序可以遵循。也不能详细说明。这就是为什么我不能教我的孩子们，他们也不能完全地学到我所知的。所以即使在70岁的成熟年龄，我还是要制作木轮！

同样的，古人深邃的智慧不能传给后代。记录下来的只不过是古人的垃圾而已。”

国王很喜欢这个逻辑，他赦免了木匠并且还给他丰厚的奖赏。

* * * * *

记录下的文字无法表达圣贤人教导的精髓。

即使禅宗各派也意识到传授开悟人的教导必须“不借助文字或语言。”换句话说，我们教导我们的学生自己经历而不是给他们知识。

世人高估了知识和知见，而没有注重通过个人训练来获得真智慧。`
 },
 { title: "輕視他人",
 date: "2019-03-01",
 shortText: `Tử Kích (TK)是位富貴的官員。他看到一位貧窮的知名學者Điền Tử Phương (DTP),立即下車去跟他打招呼。DTP却完全不理睬TK。
 
TK很不高興地說：“富貴的人有權利輕視他人，貧窮而又一無所有的人也可以有同樣的權利嗎？”`,
 fullText: `Tử Kích (TK)是位富貴的官員。他看到一位貧窮的知名學者Điền Tử Phương (DTP),立即下車去跟他打招呼。DTP却完全不理睬TK。
 
TK很不高興地說：“富貴的人有權利輕視他人，貧窮而又一無所有的人也可以有同樣的權利嗎？”
​DTP回答說：“貧賤的人當然有權利對別人不屑一顧。高貴的人怎麼敢這麼做呢？一位怠慢他人的國王可以失去他的國家，一個輕視他人的官員可以失去他的官位。對一位有能力但一無所有的人（像我這樣的人）來說，他不論去何處，國王和官員們都不重視他的忠告，也不實行他的策略，他輕視他人又對自己有什麼損失呢？”
 
TK 聽了以後向DTP道歉。
 
TK 因為有錢有權而傲慢。DTP因為有才智而傲慢。這件趣事相對錢勢來說更偏向才智。
但是這只是普通人相對起品德來說更看重物質或知識的方式。不管一個人窮而慧或者富而貴，傲慢反映了一個大自我在无情地造罪，因此造成日後痛苦和苦難的報應。
 
不論你的财富，地位和才智，謙卑你才會更快樂。`
 },
 { title: "忘記自己的兒子",
 date: "2019-02-01",
 shortText: `有一位奉行孔夫子教導祭祖的官員，在祭祖的時候忘記讓自己的兒子參加祭奠。
 
孔夫子聽說了以後評論說：“這個人會在兩年內失去官位。”
 
那位官員的確在一年以後失業了。孔夫子的學生們問他們的老師是怎麼知道的。`,
 fullText: `有一位奉行孔夫子教導祭祖的官員，在祭祖的時候忘記讓自己的兒子參加祭奠。
 
孔夫子聽說了以後評論說：“這個人會在兩年內失去官位。”
 
那位官員的確在一年以後失業了。孔夫子的學生們問他們的老師是怎麼知道的。
​孔夫子解釋道：“祭祖是為了對祖先們表示感恩，但是他在祭奠時忽略了自己的兒子。這明確地表示他很容易忘記很多重要的事情。因此沒有辦法，他最終一定會失去官位。”
 
一個聰明人必須保全自己的根基，不然他就變得不可靠了。`
 },
 { title: "教导孩子们正义",
 date: "2019-02-01",
 shortText: `正义是美好而又有意义的人生的一部分。正义是指处在道德上正确或者合理的状态，也被认为是美德。
古人怎么形容正义的人生呢？

他们说：“如果我们可以每天听到、看到有人做一件正义的事情，并且自己也做一件正义的事情，那么那一天就没有白过。”`,
 fullText: `正义是美好而又有意义的人生的一部分。正义是指处在道德上正确或者合理的状态，也被认为是美德。
古人怎么形容正义的人生呢？

他们说：“如果我们可以每天听到、看到有人做一件正义的事情，并且自己也做一件正义的事情，那么那一天就没有白过。”
我们该怎么教导我们的孩子们正义呢？我们的教育家所提倡的并不是建立在正义的基础上的，所以依靠他们是不够的。作为替代，每天以身作则，帮助孩子们听到、看到并且做一些正义的事情。这样才可以确保我们的孩子们有一个美好的未来。
​
佛陀在三千年前也是这么做的，最好的教育是做一个好榜样。好家长的最重要的责任之一就是以身作则。`
 },
 { title: "没有比这更好的了......",
 date: "2018-12-01",
 shortText: `古人说：“没有什么比练习更能熟练技能了：因此，我们会提醒孩子们做功课，因为那是他们的义务。成年人需要时时练习才能完善他们的技能。

没有什么比有耐心更清净了：当我们想独自一人呆一会时，生活中充满了障碍和挑战。当我们想从问题和挑战中逃走时，我们必须要学会如何耐心得忍受它们：暴风雨一定会过去的。`,
 fullText: `
古人说：“没有什么比练习更能熟练技能了：因此，我们会提醒孩子们做功课，因为那是他们的义务。成年人需要时时练习才能完善他们的技能。

没有什么比有耐心更清净了：当我们想独自一人呆一会时，生活中充满了障碍和挑战。当我们想从问题和挑战中逃走时，我们必须要学会如何耐心得忍受它们：暴风雨一定会过去的。
没有什么比做好事更有意义了。如是因，如是果。只要做好事，好事就会发生在你身上。
 
没有人比圣贤人更棒的了。他们是社会结构的重要元素和真正栋梁。”

练习禅修是一个最有效地开发和增强耐心的方法之一。
`
 },
 { title: "许由洗耳",
 date: "2018-11-01",
 shortText: `尧帝想把天下让给隐士许由 。许由听了就逃往箕山继续过隐居生活。
 
之后尧帝又再次劝请。许由匆忙起身到附近的河边洗耳。这时另一位隐士巢父正好牵着他的牛来河边饮水。巢父问许由为何洗耳。许由叙述了尧帝的劝请。巢父说，“我正打算让我的牛饮水，不过这水已经被污染了。”于是他牵着牛去上游饮水。`,
 fullText: `尧帝想把天下让给隐士许由 。许由听了就逃往箕山继续过隐居生活。
 
之后尧帝又再次劝请。许由匆忙起身到附近的河边洗耳。这时另一位隐士巢父正好牵着他的牛来河边饮水。巢父问许由为何洗耳。许由叙述了尧帝的劝请。巢父说，“我正打算让我的牛饮水，不过这水已经被污染了。”于是他牵着牛去上游饮水。
古人实在非常清高。许由听了尧帝让名利的请求就需要洗耳已经很不可思议。更甚者，巢父清高到不能让他的牛遭到染污。`
 },
 { title: "及时改过",
 date: "2018-10-01",
 shortText: `孟子说：“有人每天都在邻居那里偷一只鸡。当他被告知这是不诚实的行为时，他说：‘你完全正确！但是让我马上停下来我也做不到。这样吧，从现在开始我每月只偷一只鸡，一年以后我就不偷了。’”
 
这样的行为可以接受吗？

我们意识到自己错误的时候应当立即改过。`,
 fullText: `孟子说：“有人每天都在邻居那里偷一只鸡。当他被告知这是不诚实的行为时，他说：‘你完全正确！但是让我马上停下来我也做不到。这样吧，从现在开始我每月只偷一只鸡，一年以后我就不偷了。’”
 
这样的行为可以接受吗？

我们意识到自己错误的时候应当立即改过。
如果我们不及时改过，错误会越积越多以导致破坏性的后果。

佛教导我们：“不要认为小恶不用注意，不要认为小善可以忽略。”`
 },
 { title: "坚守真理",
 date: "2018-09-01",
 shortText: ` 有个男人在山里找到一块玉石献给国王。

 国王让他的珠宝专员检验玉石，专员认为是假的。国王下令砍掉男人的左脚做为惩罚。

后来王子继承了父亲的王位，男人又把玉石献供给新国王。他的珠宝专员宣称玉石还是假的。所以新国王下令砍掉男人的右脚做为惩罚。`,
 fullText: `有个男人在山里找到一块玉石献给国王。

 国王让他的珠宝专员检验玉石，专员认为是假的。国王下令砍掉男人的左脚做为惩罚。

后来王子继承了父亲的王位，男人又把玉石献供给新国王。他的珠宝专员宣称玉石还是假的。所以新国王下令砍掉男人的右脚做为惩罚。
之后又有一个新国王继任王位。男人抱着他的玉石痛哭了三天三夜直到流下血泪。新国王听说之后就问他为何哭泣。

男人说道：“我不是为自己的脚而哭泣。我因为我的玉石被认作石头，我真实的话语被认为不真实而难过。”

世人都很困惑。时常认假为真，又认真为假。

当我们遇到困境的时候，需要很大的勇气去坚守真理。尽管如此，坚守真理仍然是我们做人应尽的责任。`
 },
 { title: "诚信",
 date: "2018-08-01",
 shortText: `一天曾子的妻子要去集市，但是他们的孩子哭着要和她一起去。于是她对孩子说：“你在家做个乖孩子，等我回家给你做猪肉当晚饭。”

曾子的妻子从集市回来，曾子告诉她说杀猪做晚饭。她说：“我不是说真的！”

曾子说：“你怎么可以这样呢？不要以为孩子不懂事，他们会模仿父母的行为。如果我们欺骗他，不就是教他说谎吗？”
​
所以曾子就杀猪让孩子吃猪肉。

领导者绝对不可以说谎，不然会对他们的追随者造成严重而长久的伤害。`,
 fullText: null
 }
];

function Blog() {

  return (
    <><NavigationBar/>
    {/* Main Content */}
  <Layout>
<Table><tbody><tr><td>
{stories.map((story, index) => (
  <div key={index} className="bg-white shadow-lg rounded-lg overflow-hidden">
    <div className="p-4">
      <Typography variant="h3">{story.title}</Typography>
      <Typography variant="body1">{new Date(story.date).toLocaleDateString()}</Typography>
      <hr/>

      <ExpandableText shortText={story.shortText} fullText={story.fullText} />
    </div>
  </div>
))}
</td><td></td></tr></tbody></Table><br/>
  </Layout></>
  );
}

export default Blog;
